var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3783_2966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4319 0H5.56804C2.49776 0 0 2.55781 0 5.70175V15.2983C0 18.4422 2.49776 21 5.56804 21H22.4319C25.5022 21 28 18.4422 28 15.2983V5.70175C28 2.55781 25.5022 0 22.4319 0ZM26.8571 15.2983C26.8571 17.7988 24.8719 19.8333 22.4319 19.8333H5.56804C3.12804 19.8333 1.14286 17.7988 1.14286 15.2983V5.70175C1.14286 3.20123 3.12804 1.16667 5.56804 1.16667H22.4319C24.8719 1.16667 26.8571 3.20123 26.8571 5.70175V15.2983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0631 10.2903L11.1459 5.55637C10.9701 5.45131 10.7508 5.44956 10.5731 5.55357C10.3953 5.65752 10.2857 5.85061 10.2857 6.05967V15.5264C10.2857 15.7354 10.3953 15.9285 10.5728 16.0325C10.6609 16.084 10.7592 16.1097 10.8571 16.1097C10.957 16.1097 11.0566 16.0829 11.1459 16.0297L19.0631 11.2969C19.238 11.1924 19.3457 11.0007 19.3457 10.7936C19.3457 10.5865 19.2383 10.3948 19.0631 10.2903ZM11.4286 14.5086V7.07741L17.6434 10.7936L11.4286 14.5086Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3783_2966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingIcon);
export default __webpack_public_path__ + "static/media/MarketingIcon.9a479b6ff0d99f934048968989af0170.svg";
export { ForwardRef as ReactComponent };